import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ICategory } from "./types/_category";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IMedia } from "./types/_news";
const api = new APIClient();

const path = '/categories';
const categoryApi = {
  allCategory(params: any = {}): Promise<AxiosResponse<ResponseData<ICategory[]>, any>> {
    const url = `masters/categories`
    return api.get(url, params)
  },
  getAllMedia(params: any = {}): Promise<AxiosResponse<ResponseData<IMedia[]>, any>> {
    const url = `masters/medias`
    return api.get(url, params)
  },
}
export default categoryApi
